import { EditIcon } from "@chakra-ui/icons";
import { Box, Button, Container, Flex, Spacer, Text, Image, Heading, Divider, SimpleGrid, Grid, GridItem, ButtonGroup, IconButton } from "@chakra-ui/react";
import moment from "moment";
import { ReactElement, useEffect, useState } from "react";
import { FiFacebook, FiGlobe, FiInstagram, FiMapPin, FiTwitter } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import LoadingScreen from "../../../components/loading-screen";
import AuthService from "../../../services/auth/auth-service";
import Layout from "../../layouts";
import LayoutAccount from "../layout-account";

const Profile = (): ReactElement => {
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState<boolean>(true);
    const [userProfile, setUserProfile] = useState<any>(null);

    useEffect(() => {
        setLoading(true);
        AuthService.GetLoggedInUserProfile().then((res: any) => {
            setUserProfile(res.result);
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    if (isLoading)
        return (<LoadingScreen />)

    return (
        <Layout>
            <Container maxWidth={"8xl"} pt={10}>
                <LayoutAccount>
                    <Box>
                        <Flex>
                            <Text fontSize={'3xl'} fontWeight={"bold"}>My Profile</Text>
                            <Spacer />
                            {/*<Button ml={2} variant={"outline"} onClick={() => { navigate('/profile/edit') }}>Edit profile</Button>*/}
                        </Flex>
                        <Box rounded={'lg'} boxShadow={'md'} p={8}>
                            <Grid templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(5, 1fr)' }} gap={4}>
                                <GridItem>
                                    <Box boxSize={"200px"}>
                                        <Image rounded={'lg'} src={userProfile.profilePictureFullUrl || 'https://res.cloudinary.com/ruang-trader/image/upload/v1652634569/logosvillage/default-iser_nvxogs.webp'} />
                                    </Box>
                                </GridItem>
                                <GridItem colSpan={4}>
                                    <Box>
                                        <Heading fontSize={'2xl'} fontWeight={'extrabold'}>{userProfile.fullName}</Heading>
                                        <Text fontSize={'sm'} mt={2}>{userProfile.emailAddress}</Text>
                                        <Flex alignItems={'center'} fontSize={'sm'} mt={2}>
                                            <FiMapPin />
                                            <Text ml={2}>{userProfile.city ? `${userProfile.city}, ${userProfile.country}` : '-'}</Text>
                                        </Flex>

                                        <Text fontSize={'sm'} mt={10}>Date Of Birth</Text>
                                        <Text fontSize={'sm'} mt={1} fontWeight={'bold'}>{userProfile.dateOfBirth ? moment(userProfile.dateOfBirth).format("DD MMMM yyyy") : '-'}</Text>
                                    </Box>
                                </GridItem>
                            </Grid>
                            <Divider my={5} />
                            <Box>
                                <Heading fontSize={'md'} fontWeight={'bold'}>Pekerjaan</Heading>
                                <SimpleGrid columns={{ base: 1, md: 2 }}>
                                    <Box py={4} flex={1}>
                                        <Text fontSize={'sm'} color={'gray.500'}>Profesi</Text>
                                        <Text fontSize={'sm'} fontWeight={'bold'}>{userProfile.workProfession || '-'}</Text>
                                    </Box>
                                    <Box py={4} flex={1}>
                                        <Text fontSize={'sm'} color={'gray.500'}>Industri</Text>
                                        <Text fontSize={'sm'} fontWeight={'bold'}>{userProfile.workIndustry || '-'}</Text>
                                    </Box>
                                </SimpleGrid>
                            </Box>
                            <Divider my={5} />
                            <Box>
                                <Heading fontSize={'md'} fontWeight={'bold'}>Tentang saya</Heading>
                                <Flex>
                                    <Box py={4}>
                                        <Text fontSize={'sm'}>
                                            {userProfile.about || '-'}
                                        </Text>
                                    </Box>
                                </Flex>
                            </Box>
                            <Divider my={5} />
                            <Box>
                                <Heading fontSize={'md'} fontWeight={'bold'}>Sosial Media</Heading>
                                <SimpleGrid columns={{ base: 1, md: 2 }}>
                                    <Box py={4}>
                                        <Flex alignItems={'center'}>
                                            <FiGlobe />
                                            <Text ml={2} fontSize={'sm'} color={'gray.500'}>Website</Text>
                                        </Flex>
                                        <Text fontSize={'sm'} fontWeight={'bold'}>{userProfile.website || '-'}</Text>
                                    </Box>
                                    <Box py={4}>
                                        <Flex alignItems={'center'}>
                                            <FiFacebook />
                                            <Text ml={2} fontSize={'sm'} color={'gray.500'}>Facebook</Text>
                                        </Flex>
                                        <Text fontSize={'sm'} fontWeight={'bold'}>{userProfile.facebook || '-'}</Text>
                                    </Box>
                                </SimpleGrid>
                                <SimpleGrid columns={{ base: 1, md: 2 }}>
                                    <Box py={4}>
                                        <Flex alignItems={'center'}>
                                            <FiTwitter />
                                            <Text ml={2} fontSize={'sm'} color={'gray.500'}>Twitter</Text>
                                        </Flex>
                                        <Text fontSize={'sm'} fontWeight={'bold'}>{userProfile.twitter || '-'}</Text>
                                    </Box>
                                    <Box py={4}>
                                        <Flex alignItems={'center'}>
                                            <FiInstagram />
                                            <Text ml={2} fontSize={'sm'} color={'gray.500'}>Instagram</Text>
                                        </Flex>
                                        <Text fontSize={'sm'} fontWeight={'bold'}>{userProfile.instagram || '-'}</Text>
                                    </Box>
                                </SimpleGrid>
                            </Box>
                        </Box>
                    </Box>
                </LayoutAccount>
            </Container>
        </Layout>
    );
};

export default Profile;